<template>
  <component :is="logoComponent" v-bind="mergedProps" />
</template>

<script setup>
import { computed, useAttrs } from "vue";
import { useBrandingStore } from "@/stores/branding";
import KealLogo from "@/components/KealLogo.vue";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  src: {
    type: String,
    default: "",
  },
  alt: {
    type: String,
    default: "",
  },
  variant: {
    type: String,
    default: "",
  },
});

const attrs = useAttrs();
const brandingStore = useBrandingStore();

const baseUrl = computed(() =>
  // if development, use empty string as base URL to load from public folder
  process.env.NODE_ENV === "development"
    ? ""
    : brandingStore.branding?.baseUrl || "",
);

const logoVariant = computed(() => {
  if (!props.variant) return null;
  return brandingStore.branding?.logo?.variants?.[props.variant]
    ? `${baseUrl.value}${brandingStore.branding?.logo?.variants?.[props.variant]?.src}`
    : null;
});

const logoSrc = computed(
  () =>
    props.src ||
    logoVariant.value ||
    `${baseUrl.value}${brandingStore.branding?.logo?.src}` ||
    "",
);

const logoAlt = computed(
  () =>
    props.alt ||
    logoVariant.value?.alt ||
    brandingStore.branding?.logo?.alt ||
    "Logo",
);

const logoComponent = computed(() => (logoSrc.value ? "img" : KealLogo));

const logoProps = computed(() =>
  logoSrc.value
    ? {
        src: logoSrc.value,
        alt: logoAlt.value,
        decoding: "async",
        loading: "eager",
      }
    : {},
);

const mergedProps = computed(() => ({
  ...logoProps.value,
  ...attrs,
}));
</script>
